<template>
  <div>
    <h2>Tabela</h2>
    <form action="" class="" @submit.prevent="submit">
      <md-field :class="getValidationClass('label')">
        <label for="label">Título</label>
        <md-input id="label" v-model="label" />
        <span v-if="$v.label" class="md-error">Título obrigatório</span>
      </md-field>

      <md-field :class="getValidationClass('ultimosMeses')">
        <label for="ultimosMeses">Quantidade de meses</label>
        <md-input id="ultimosMeses" v-model="ultimosMeses" type="number" />
        <span v-if="$v.label" class="md-error"
          >Quantidade de meses obrigatório</span
        >
      </md-field>

      <div class="md-layout md-alignment-center-left md-gutter">
        <sensor-virtual-autocomplete
          id="sensorVirtualId"
          v-model="sensorVirtualId"
          class="md-layout-item md-size-75"
          name="sensorVirtualId"
          :local-id="localId"
          :should-filter-out-sensor-virtual-fn="shouldFilterOutSensorVirtualFn"
          :label="'Sensores virtuais (somente com periodo mensal)'"
        />
        <div class="md-layout-item md-list-action">
          <md-button
            class="md-primary md-raised"
            @click="() => adicionarSensorLista(sensorVirtualId)"
          >
            Adicionar
          </md-button>
        </div>
      </div>

      <md-table class="unlimited">
        <md-table-row>
          <md-table-head>Sensores Virtuais Selecionados</md-table-head>
          <md-table-head />
        </md-table-row>
        <md-table-row
          v-for="sensor in sensoresVirtuaisSelecionados"
          :key="sensor.id"
          class="pt-2 pb-2"
        >
          <md-table-cell>
            <div>
              <span>{{ sensor.titulo }}</span>
            </div>
          </md-table-cell>
          <md-table-cell class="md-toolbar-section-end">
            <md-button
              class="md-raised md-accent"
              @click="
                () => {
                  sensoresVirtuaisIds = sensoresVirtuaisIds.filter(
                    (e) => e !== sensor.id
                  )
                  sensoresVirtuaisSelecionados =
                    sensoresVirtuaisSelecionados.filter(
                      (e) => e.id !== sensor.id
                    )
                }
              "
            >
              Remover
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>

      <br />

      <div style="text-align: right; width: 100%">
        <md-button class="md-raised md-accent" @click="() => $emit('close')">
          Cancelar
        </md-button>
        <md-button type="submit" class="md-raised md-primary">
          {{ isEdit ? 'Editar' : 'Cadastrar' }}
        </md-button>
      </div>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import { EventBus, Topics, Types } from '@/event-bus'
import querySensoresVirtuaisMixin from '@/mixins/query.mixin'
import { ComponenteTipo } from '@/utils/componente'
import { VirtualSensorPeriodoTipo } from '@/utils/constants'
import http from '@/utils/http'

import SensorVirtualAutocomplete from '../../autocomplete/SensorVirtualAutocomplete.vue'

export default {
  name: 'ViewTabelaSensorVirtualMensalForm',
  components: { SensorVirtualAutocomplete },
  mixins: [validationMixin, querySensoresVirtuaisMixin],
  props: {
    localId: {
      type: String,
      required: true,
    },
    viewId: {
      type: String,
      required: true,
    },
    componente: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      sensorVirtualId: null,
      label: '',
      ultimosMeses: 12,
      sensoresVirtuaisIds: [],
      sensoresVirtuaisSelecionados: [],
      sensoresVirtuais: [],
    }
  },
  validations: {
    label: { required },
    ultimosMeses: { required },
  },
  computed: {
    isEdit() {
      return this.componente !== null
    },
  },
  async beforeMount() {
    if (this.componente !== null) {
      // Copia: atribuir a referencia faria os push/filter daqui e da tabela
      // mutarem o value do componente pai.
      this.sensoresVirtuaisIds = [...this.componente.value.sensoresVirtuaisIds]
      this.ultimosMeses = this.componente.value.ultimosMeses
      this.label = this.componente.value.label
    }

    await this.loadSensoresVirtuais()

    if (this.componente !== null) {
      this.sensoresVirtuaisSelecionados = this.sensoresVirtuais.filter((e) =>
        this.sensoresVirtuaisIds.includes(e.id)
      )
    }
  },
  methods: {
    shouldFilterOutSensorVirtualFn(sensorVirtual) {
      return !(sensorVirtual.periodoTipo === VirtualSensorPeriodoTipo.Mensal)
    },
    adicionarSensorLista(sensorVirtualId) {
      if (sensorVirtualId === null) return

      if (this.sensoresVirtuaisIds.find((x) => x === sensorVirtualId)) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          title: 'Sensor Virtual já adicionado',
          message: '',
          type: Types.WARNING,
        })
        return
      }

      const sensor = this.sensoresVirtuais.find((x) => x.id === sensorVirtualId)
      if (sensor === null) {
        return
      }

      this.sensoresVirtuaisIds.push(sensorVirtualId)
      this.sensoresVirtuaisSelecionados.push(sensor)

      this.sensorVirtualId = null
    },
    async loadSensoresVirtuais() {
      this.sensoresVirtuais = await http
        .get(`local/${this.localId}/sensor/virtual`)
        .then((e) =>
          (e?.sensoresVirtual ?? []).filter(
            (x) => x.periodoTipo === VirtualSensorPeriodoTipo.Mensal
          )
        )
    },
    async submit() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      if (this.ultimosMeses < 1) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'O número de meses deve ser maior que 0',
        })
        return
      }

      let response

      const value = {
        label: this.label,
        sensoresVirtuaisIds: this.sensoresVirtuaisIds,
        ultimosMeses: this.ultimosMeses,
      }

      if (this.isEdit) {
        response = await http.put(`/view/componente`, {
          id: this.componente.id,
          value: value,
          z: this.componente.z,
        })
      } else {
        response = await http.post(`/view/componente`, {
          tipo: ComponenteTipo.TabelaSensoresVirtuais,
          viewId: this.viewId,
          value: value,
        })
      }

      if (response) {
        this.$emit('close')
        this.$emit('updated')
      }
    },
    getValidationClass(fieldName) {
      const field = this.$v[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
  },
}
</script>

<style scoped></style>
